// extracted by mini-css-extract-plugin
module.exports = {"root":"createPopoverContent_root__3mO-O"};